import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { FormFields } from '@epi-forms/helpers';
import { ON_HOLD, Payment, Schedule } from '@epi-constants/benefitTypes';
import { topupSliceActions } from '@epi-store/topup/topup.slice';
import { TopupFormType } from '@epi-pages/LoadBenefit/components/Topup/TopupForm';

export const useTopupFormContext = () => {
  const dispatch = useDispatch();

  const form = useForm<TopupFormType>({
    mode: 'onChange',
    defaultValues: {
      [FormFields.MoneyAmount]: '',
      [FormFields.Page]: 1,
      [FormFields.CheckableEmployees]: [],
      [FormFields.ScheduleType]: Schedule.Direct,
      [FormFields.ScheduleDate]: ''
    }
  });

  const { watch } = form;
  const checkableEmployees = watch(FormFields.CheckableEmployees);

  useEffect(() => {
    const isOnHoldEmployee = !!checkableEmployees.find(
      employee => employee.employmentType === ON_HOLD
    );

    if (isOnHoldEmployee) {
      dispatch(topupSliceActions.toggleShowTable(true));
    }
  }, [checkableEmployees]);

  useEffect(() => {
    return () => {
      dispatch(topupSliceActions.toggleShowTable(false));
    };
  }, []);

  return { form };
};
